import { render, staticRenderFns } from "./ProductRank.vue?vue&type=template&id=0c96b5bb&scoped=true&"
import script from "./ProductRank.vue?vue&type=script&lang=js&"
export * from "./ProductRank.vue?vue&type=script&lang=js&"
import style0 from "./ProductRank.vue?vue&type=style&index=0&id=0c96b5bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96b5bb",
  null
  
)

export default component.exports